import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneField.css';

/**
 * Shared international phone input — defaults to India (+91), country picker
 * searchable by name and dial code. Stores E.164 in `value`.
 *
 * Props:
 *   value         - E.164 string ("+919876543210") OR raw digits (legacy)
 *   onChange(v)   - called with E.164 string ("+91987...") or "" if cleared
 *   placeholder
 *   disabled
 *   error         - boolean (renders red border)
 *   testId
 *   inputProps    - additional props applied to the underlying <input/>
 */
export default function PhoneField({
  value,
  onChange,
  placeholder = 'Phone number',
  disabled = false,
  error = false,
  testId,
  inputProps = {},
}) {
  // react-phone-input-2 strips the leading '+' from the value it passes back;
  // we re-prefix here so callers always receive E.164.
  const handleChange = (v) => {
    const next = v ? (v.startsWith('+') ? v : `+${v}`) : '';
    onChange(next);
  };

  return (
    <div data-testid={testId} className={`tmc-phone-wrap ${error ? 'tmc-phone-error' : ''}`}>
      <PhoneInput
        country={'in'}
        value={value || ''}
        onChange={handleChange}
        enableSearch
        countryCodeEditable={false}
        searchPlaceholder="Search country or dial code"
        placeholder={placeholder}
        disabled={disabled}
        disableSearchIcon
        inputProps={{
          'data-testid': testId ? `${testId}-input` : undefined,
          autoComplete: 'tel',
          ...inputProps,
        }}
        containerClass={`w-full ${error ? 'tmc-phone-error-container' : ''}`}
        inputClass="!w-full !h-9 !pl-12 !pr-3 !text-sm !rounded-xl !border !border-[#E5F2F1] focus:!border-[#0D8B7D] focus:!ring-2 focus:!ring-[#0D8B7D]/20"
        buttonClass="!rounded-l-xl !border-r-0 !border !border-[#E5F2F1] !bg-white"
        dropdownClass="!rounded-xl !shadow-lg"
        searchClass="!rounded-lg !my-2 !mx-2"
      />
    </div>
  );
}
